// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as React from 'react'
import styled from 'styled-components'

export { default as IconSources } from '@/icons'

type Props = {
  name: any
  onClick?: () => void
  size?: number
}

type StyledIconProps = {
  height?: number
}

const StyledIcon = styled.img<StyledIconProps>`
  display: inline;

  ${(props) => {
    if (props.onClick) {
      return 'cursor: pointer;'
    }
  }}

  ${(props: { height?: number }) => {
    if (props.height) {
      return `height: ${props.height}px;`
    }
  }}
`

function Icon({ name, onClick, size }: Props) {
  return (
    <StyledIcon
      alt="icon"
      height={size}
      onClick={onClick}
      src={name}
      width={size}
    />
  )
}

export default Icon
